import { tupleToStringKey } from 'js/lib/stringKeyTuple';

import type {
  GradedDiscussionPromptContent,
  GradedProgrammingContent,
  GradedQuizContent,
  PhasedPeerContent,
  StaffGradedContent,
} from 'bundles/author-common/types/Item';
import type Item from 'bundles/author-course/models/Item';

/**
 * Return a promise that will resolve after X milliseconds
 * in order to delay execution of a chain.
 * @param ms
 */
export function delay(ms = 0): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

export function getIdForProctorConfigOverride({
  assessmentId,
  userId,
}: {
  assessmentId: string;
  userId: number | string;
}) {
  return tupleToStringKey(['SPECIFIC', assessmentId, userId]);
}

export const getAssessmentId = (item: Item) => {
  if (!item || !item.content) return '';

  switch (item?.typeName) {
    case 'exam':
      return (item?.content as GradedQuizContent)?.definition?.assessmentId;
    case 'staffGraded':
      return (item?.content as StaffGradedContent)?.definition?.assignmentId;
    case 'phasedPeer':
    case 'peer':
      return (item?.content as PhasedPeerContent)?.definition?.assignmentId;
    case 'gradedProgramming':
      return (item?.content as GradedProgrammingContent)?.definition?.programmingAssignmentId;
    case 'gradedDiscussionPrompt':
      return (item?.content as GradedDiscussionPromptContent)?.definition?.discussionPromptAssignmentId;
    default:
      return '';
  }
};
